import React, {PureComponent, Fragment} from "react";
import {Card, CardBody, Nav, NavItem, NavLink, Row, TabContent, TabPane} from "reactstrap";
import {Colxx, Separator} from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../../containers/navs/Breadcrumb";
import {withTranslation} from "react-i18next";
import ExchangeList from "./exchangeList";
import classnames from "classnames";
import UsersList from "./usersList";

class Lists extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
    };
  }

  toggle = tabIndex => {
    this.setState({
      activeTab: tabIndex,
    });
  };

  render() {
    const {t, match, history} = this.props;
    const {activeTab} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <Nav tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === 0 })}
                      onClick={() => {this.toggle(0);}}>
                      <span className="text-one cursor-pointer">{t('Exchange')}</span>
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === 1 })}
                      onClick={() => {this.toggle(1);}}>
                      <span className="text-one cursor-pointer">{t('Users')}</span>
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId={0}>
                    <ExchangeList history={history}/>
                  </TabPane>
                  <TabPane tabId={1}>
                    <UsersList history={history}/>
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(Lists);
